export enum BRANDS {
  BINGO = 'bingo',
  PRIZES = 'prizes',
  SPINS = 'spins',
}

export enum ItvCollectionType {
  PROMOTIONS = 'promotions',
  BINGO = 'bingo',
  GAMES = 'games',
  BINGO_GAMES = 'bingo+game',
  RECENTLY_PLAYED_GAMES = 'recently_played_games',
}

export type AvailableBrands = 'bingo' | 'spins';
